export default __webpack_public_path__ + "static/hq14-24dee2adfa5e2166edf6a3d04f7655ee.jpg";